import { render, staticRenderFns } from "./FormTransport.vue?vue&type=template&id=65db1fa4&scoped=true"
import script from "./FormTransport.vue?vue&type=script&lang=js"
export * from "./FormTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db1fa4",
  null
  
)

export default component.exports